import { render, staticRenderFns } from "./OidcCallback.vue?vue&type=template&id=72cdc978"
import script from "./OidcCallback.vue?vue&type=script&lang=js"
export * from "./OidcCallback.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\Administrator\\.jenkins\\workspace\\tplt.10ndata.com\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('72cdc978')) {
      api.createRecord('72cdc978', component.options)
    } else {
      api.reload('72cdc978', component.options)
    }
    module.hot.accept("./OidcCallback.vue?vue&type=template&id=72cdc978", function () {
      api.rerender('72cdc978', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/OidcCallback.vue"
export default component.exports